export function findReactFlowTabset(layout: any): any {
    if (!layout || !layout.children) {
        return null;
    }

    for (const child of layout.children) {
        if (child.type === 'tabset' && child.children.some((tab: any) => tab.component === 'ReactFlowTab')) {
            return child;
        }

        // Si el elemento tiene hijos, realiza la búsqueda recursiva
        const found = findReactFlowTabset(child);
        if (found) {
            return found;
        }
    }

    return null;
}